export default __webpack_public_path__ + "static/media/marimba-high-roll-short-soft-no-delay.846e5b37.wav";